/**
 * API Endpoints - Single source of truth
 * All endpoint configurations should reference this file
 */

export interface ApiEndpoint {
    id: string;
    name: string;
    url: string;
}

export const API_ENDPOINTS: ApiEndpoint[] = [
    { id: 'local', name: 'Local', url: 'http://localhost:8080' },
    {
        id: 'test',
        name: 'Test',
        url: 'https://search-test-test-62881363641.europe-west9.run.app',
    },
    {
        id: 'development',
        name: 'Development',
        url: 'https://search-development-development-62881363641.europe-west9.run.app',
    },
    {
        id: 'staging',
        name: 'Staging',
        url: 'https://search-staging-staging-62881363641.europe-west9.run.app',
    },
    {
        id: 'production',
        name: 'Production',
        url: 'https://search-production-production-62881363641.europe-west9.run.app',
    },
];

export const DEFAULT_ENDPOINT_ID = 'test';
